








































































import { DISCOUNT_TYPE, OFFER_TYPE, capitalizeFirstLetter } from '@/store/shared';
import { formatSmallMoney } from '@/helpers/jsUtils';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'CustomerSessionCard',
  props: {
    session: {
      type: Object as PropType<any>,
    },
  },
  data() {
    return {
      OFFER_TYPE,
      DISCOUNT_TYPE,
      capitalizeFirstLetter,
      formatSmallMoney,
    };
  },
  methods: {
    view(session: any) {
      this.$emit('view', session);
    },
  },
});
